/**
 * Whether a nav link's href is "active" for the current pathname.
 *
 * Shared by PageNavMenu and PageNavDrawerMenu so the active-state rule stays in
 * one place - a divergence between the desktop and drawer menus would be a
 * hard-to-spot highlighting bug.
 *
 * - Empty href (e.g. a dropdown/group trigger that doesn't navigate) never
 *   matches.
 * - Exact pathname match is always active.
 * - When `matchSubPaths` is set, a nested path under the href (`href + "/"`)
 *   also counts as active.
 */
export const matchesPath = (
  href: string,
  pathname: string,
  matchSubPaths: boolean
): boolean => {
  if (!href) return false;
  if (pathname === href) return true;
  if (matchSubPaths && pathname.startsWith(href + "/")) return true;
  return false;
};
